import { render, staticRenderFns } from "./SelectorBlock.vue?vue&type=template&id=e3380868&"
import script from "./SelectorBlock.vue?vue&type=script&lang=js&"
export * from "./SelectorBlock.vue?vue&type=script&lang=js&"
import style0 from "./SelectorBlock.vue?vue&type=style&index=0&id=e3380868&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports